import { useDispatch, useSelector } from "react-redux"
import { Box, Button, FormControl, FormLabel, Grid, Input, Modal, ModalDialog, Sheet, Stack, Table, Typography } from "@mui/joy";
import { removeError } from "./GeneralErrorSlice";


function GeneralErrorDialog() {
    var error = useSelector((state) => state.generalError.error)
    var dispatch = useDispatch()
    var close = () => {
        dispatch(removeError())
    }

    return error == null ? "": 
    <Modal open={true} onClose={close}>
    <ModalDialog
        aria-labelledby="basic-modal-dialog-title"
        aria-describedby="basic-modal-dialog-description"
        sx={{ maxWidth: 500 }}
    >
        <Typography id="basic-modal-dialog-title" component="h2">
           General Error
        </Typography>
            <Stack spacing={2}>
                <Box>
                    <b>Where:</b> {error.where}
                </Box>
                <Box>
                    <b>Code:</b> {error.code}
                </Box>
                <Box>
                    <b>Status:</b> {error.status}
                </Box>
                <Box>
                    <b>Message:</b> {error.message}
                </Box>
                <Box>
                    <b>Tem payload:</b> {error.payload != null ? <Button onClick={() => console.log(error.payload)}>Console.log it!</Button> : "Não"}
                </Box>
            </Stack>
    </ModalDialog>
</Modal>
}

export default GeneralErrorDialog

